// extracted by mini-css-extract-plugin
module.exports = {"IconLabelStatusOk":"IconLabelStatusOk_vZlPC"};